// Barra lateral verde (print de referência / Figma 5.1) — telas a partir de 768 px.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppState } from '../state/AppStore';
import { useNav, type View } from '../state/services';
import { useAccess } from '../state/useSubscription';
import { BeeLogo, Icon, type IconName } from './Icon';
import { cls } from './NewTaskForm';

export const NAV_ITEMS: Array<{ view: View; icon: IconName; label: string }> = [
  { view: 'tasks', icon: 'list', label: 'nav.tasks' },
  { view: 'focus', icon: 'timer', label: 'nav.focus' },
  { view: 'settings', icon: 'settings', label: 'nav.settings' },
  { view: 'subscription', icon: 'card', label: 'nav.subscription' },
];

function initials(name: string, email: string): string {
  const base = name.trim() || email;
  const parts = base.split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '🐝';
}

export function Sidebar() {
  const { t } = useTranslation();
  const nav = useNav();
  const session = useAppState((s) => s.session);
  const profile = useAppState((s) => s.profile);
  const access = useAccess();
  const [collapsed, setCollapsed] = useState(false);
  const name = profile?.name || session?.user.name || '';

  return (
    <aside className={cls('sidebar', collapsed && 'sidebar--collapsed')} data-testid="sidebar">
      <div className="sidebar__brand">
        <span className="sidebar__logo">
          <BeeLogo size={26} />
        </span>
        <span className="sidebar__name">{t('app.name')}</span>
        <button type="button" className="sidebar__collapse" aria-label={collapsed ? t('nav.expand') : t('nav.collapse')} onClick={() => setCollapsed(!collapsed)}>
          <Icon name={collapsed ? 'chevronRight' : 'chevronLeft'} size={14} />
        </button>
      </div>
      <nav className="sidebar__nav" aria-label={t('nav.label')}>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.view}
            type="button"
            className={cls('sidebar__item', nav.view === item.view && 'is-active')}
            aria-current={nav.view === item.view ? 'page' : undefined}
            onClick={() => nav.go(item.view)}
          >
            <span className="sidebar__icon">
              <Icon name={item.icon} size={15} />
            </span>
            <span className="sidebar__label">{t(item.label)}</span>
          </button>
        ))}
      </nav>
      <div className="sidebar__user">
        <span className="avatar">{initials(name, session?.user.email ?? '')}</span>
        <span className="sidebar__who">
          <strong>{name || session?.user.email}</strong>
          <small>{access.paying ? t('settings.statusActive') : t('settings.statusEnded')}</small>
        </span>
      </div>
    </aside>
  );
}
